export const blFormatPrice = (price: string) => {
    if (price !== '' && price !== null && typeof price !== 'undefined')
        return price.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return '';
};
